import { lazy } from "react";
const FormSupportGenerator = lazy(
  () => import("../pages/GeneralPages/FormSupportGenerator/FormSupportGenerator"),
);
const SaleSupportChartList = lazy(() => import("../pages/MLM/SaleSupportChart/List"));
const NRMChartList = lazy(() => import("../pages/MLM/NRMChart/List"));
const CorporateStaffList = lazy(() => import("../pages/GeneralPages/CorporateStaff/List"));
const CorporateChartList = lazy(() => import("../pages/GeneralPages/CorporateChart/List"));
const LegalChartList = lazy(() => import("../pages/Executive/LegalChart/List"));
const SecurityChartList = lazy(() => import("../pages/Executive/SecurityChart/List"));
const PayrollChartList = lazy(() => import("../pages/GeneralPages/PayrollChart/List"));
const BuAndOfficeAdminChartList = lazy(() => import("../pages/BINFPages/BuAndOfficeAdminChart/List"));
const AdministrativeAffairsChartList = lazy(
  () => import("../pages/HRINF/AdministrativeAffairsChart/List"),
);
const HrAdminChartList = lazy(() => import("../pages/HRINF/HrAdminChart/List"));
const ProductManagementChartList = lazy(() => import("../pages/MLM/ProductManagmentChart/List"));
const PurchaseInvoiceList = lazy(() => import("../pages/Financial/PurchaseInvoice/List"));
const PurchaseProformaList = lazy(() => import("../pages/Financial/PurchaseProforma/List"));
const FiscalYearList = lazy(() => import("../pages/Financial/FiscalYear/List"));
const DetailAccountGroupList = lazy(() => import("../pages/Financial/DetailAccountGroup/List"));
const BankBranchList = lazy(() => import("../pages/Financial/BankBranch/List"));
const SubsidiaryAccountList = lazy(() => import("../pages/Financial/SubsidiaryAccount/List"));
const GeneralLedgerAccountList = lazy(() => import("../pages/Financial/GeneralLedgerAccount/List"));
const AccountClassList = lazy(() => import("../pages/Financial/AccountClass/List"));
const ProcurementChartList = lazy(() => import("../pages/Financial/ProcurementChart/List"));
const FinancialInfoChartList = lazy(() => import("../pages/Financial/FinancialInfoChart/List"));
const BudgetingChartList = lazy(() => import("../pages/Financial/BudgettingChart/List"));
const CategoryManagementCharttList = lazy(() => import("../pages/MLM/CategoryManagementChart/List"));
const SkuSellerList = lazy(() => import("../pages/MLM/SkuSeller/List"));
const SkuTagList = lazy(() => import("../pages/MLM/SkuTag/List"));
const SkuTagGroupList = lazy(() => import("../pages/MLM/SkuTagGroup/List"));
const MeasurementUnitList = lazy(() => import("../pages/MLM/MeasurementUnit/List"));
const ProductNatureList = lazy(() => import("../pages/MLM/ProductNature/List"));
const SellerSupportChartList = lazy(() => import("../pages/MLM/SellerSupportChart/List"));
const ProductCategoryList = lazy(() => import("../pages/MLM/ProductCategory/List"));
const GeographicalDivisionList = lazy(() => import("../pages/MLM/GeographicalDivision/List"));
const SupervisorMarketVisitList = lazy(
  () => import("../pages/MarketVisitPages/SupervisorMarketVisit/List"),
);
const FreightBoxList = lazy(() => import("../pages/MLM/BeautyAdvisorReport/List"));
const DeliveryTariffList = lazy(() => import("../pages/MLM/DeliveryTariff/List"));
const BeautyAdvisorReportList = lazy(() => import("../pages/MLM/BeautyAdvisorReport/List"));
const BeautyAdvisorSupervisorReportList = lazy(
  () => import("../pages/MLM/BeautyAdvisorSupervisorReport/List"),
);
const BeautyAdvisorChartList = lazy(() => import("../pages/MLM/BeautyAdvisorChart/List"));
const MedicalAffairsChartList = lazy(() => import("../pages/MedRep/MedicalAffairsChart/List"));
const MedRepChartList = lazy(() => import("../pages/MedRep/MedRepChart/List"));
const SrmStockManagementChartList = lazy(() => import("../pages/MedRep/SrmStockManagementChart/List"));
const StockableObjectManagementChartList = lazy(
  () => import("../pages/MedRep/SrmStockManagementChart/List"),
);
const UserInformationList = lazy(() => import("../pages/MLM/UserInformation/List"));
const PointOfSaleList = lazy(() => import("../pages/MLM/PointOfSale/List"));
const SaleRepresentativeList = lazy(() => import("../pages/MLM/SaleRepresentative/List"));
const ContractTerminationRequestList = lazy(
  () => import("../pages/MLM/ContractTerminationRequest/List"),
);
const DefectiveProductStatementList = lazy(() => import("../pages/MLM/DefectiveProductStatement/List"));
const SpecialDiscountOfferList = lazy(
  () => import("../pages/MLM/SpecialDiscount/SpecialDiscountOffer/List"),
);
const SpecialDiscountBoxList = lazy(
  () => import("../pages/MLM/SpecialDiscount/SpecialDiscountBox/List"),
);
const SpecialDiscountList = lazy(() => import("../pages/MLM/SpecialDiscount/SpecialDiscount/List"));
const PurchaseReturnProformaWithoutUidList = lazy(
  () => import("../pages/Financial/PurchaseReturnProformaWithoutUid/List"),
);
const SaleOrderReportList = lazy(() => import("../pages/OSPPages/SaleOrder/SaleOrderReportList"));

const EntityAccessGrantsList = lazy(() => import("../pages/GeneralPages/EntityConfig/List"));
const FieldAccessGrantsList = lazy(() => import("../pages/GeneralPages/FieldConfig/List"));
const OrganizationalLevelList = lazy(
  () => import("../pages/GeneralPages/OrganizationalLevel/OrganizationalLevelList"),
);
const ApplicantInformationList = lazy(
  () => import("../pages/HRINF/ApplicantInformation/ApplicantInformationList"),
);
const PddList = lazy(() => import("../pages/HRINF/PersonnelDocumentDigitization/PddList"));
const OrganizationalTitleSalaryDifferenceList = lazy(
  () => import("../pages/HRINF/OrganizationalTitleSalaryDifference/List"),
);
const NationalCodeCellphoneOfPersonnelList = lazy(
  () => import("../pages/HRINF/NationalCodeCellphoneOfPersonnel/List"),
);
const OrganizationalTitleList = lazy(
  () => import("../pages/GeneralPages/OrganizationalTitle/OrganizationalTitleList"),
);
const OrganizationalTitleSpecificationList = lazy(
  () => import("../pages/HCM/OrganizationalTitleSpecification/List"),
);
const OrganizationalTitleGroupList = lazy(
  () => import("../pages/GeneralPages/OrganizationalTitleGroup/List"),
);
const AccountPartyList = lazy(() => import("../pages/OSPPages/AccountParty/AccountPartyList"));
const BrandList = lazy(() => import("../pages/MLM/Brand/List"));
const CargoList = lazy(() => import("../pages/OSPPages/Cargo/List"));
const CustomerCandidateList = lazy(
  () => import("../pages/OSPPages/CustomerCandidate/CustomerCandidateList"),
);
const DiscountList = lazy(() => import("../pages/OSPPages/Discount/DiscountList"));
const PKUList = lazy(() => import("../pages/OSPPages/PKU/PKUList"));
const PricesList = lazy(() => import("../pages/OSPPages/Price/PriceList"));
const SkuTagSubGroupList = lazy(() => import("../pages/MLM/SkuTagSubGroup/List"));
const ResponseList = lazy(() => import("../pages/OSPPages/Response/ResponseList"));
const SalePackList = lazy(() => import("../pages/OSPPages/SalePack/SalePackList"));
const SellingProductList = lazy(() => import("../pages/OSPPages/SellingProduct/SellingProductList"));
const UIDPList = lazy(() => import("../pages/OSPPages/UIDP/UIDPList"));
const WarehouseOperationList = lazy(
  () => import("../pages/OSPPages/WarehouseOperation/WarehouseOperationList"),
);
const SaleChartList = lazy(() => import("../pages/OSPPages/SalePersonChart/List"));
const SaleStaffList = lazy(() => import("../pages/OSPPages/SalePersonStaff/List"));
const LogisticChartList = lazy(() => import("../pages/MLM/LogisticChart/List"));
const LogisticStaffList = lazy(() => import("../pages/OSPPages/LogisticStaff/LogisticStaffList"));
const ChiefManagementChartList = lazy(
  () => import("../pages/OSPPages/ChiefManagementChart/ChiefManagementChartList"),
);
const ChiefManagementStaffList = lazy(
  () => import("../pages/OSPPages/ChiefManagementStaff/ChiefManagementStaffList"),
);
const UserList = lazy(() => import("../pages/OSPPages/User/UserList"));
const WarehouseList = lazy(() => import("../pages/OSPPages/Warehouse/WarehouseList"));
const WarehouseNoteList = lazy(() => import("../pages/OSPPages/WarehouseNote/List"));
const InvoiceReportList = lazy(
  () => import("../pages/OSPPages/Invoice/InvoiceReport/InvoiceReportList"),
);
const SkuList = lazy(() => import("../pages/MLM/SKU/List"));
const PkuList = lazy(() => import("../pages/MLM/PKU/List"));
const SkuEditList = lazy(() => import("../pages/MLM/SKUEdit/List"));
const PkuEditList = lazy(() => import("../pages/MLM/PKUEdit/List"));
const WalletList = lazy(() => import("../pages/MLM/Wallet/List"));
const ComplaintCaseList = lazy(() => import("../pages/MLM/ComplaintCase/List"));
const WarehouseGroupList = lazy(() => import("../pages/MLM/WarehouseGroup/List"));
const AdvancedChartDbacProtocolList = lazy(
  () => import("../pages/GeneralPages/AdvancedChartDbacProtocol/AdvancedChartDbacProtocolList"),
);
const AdvancedNonUserDbacProtocolList = lazy(
  () => import("../pages/GeneralPages/AdvancedNonUserDbacProtocol/AdvancedNonUserDbacProtocolList"),
);
const AdvancedOrganizationalTitleDbacProtocolList = lazy(
  () =>
    import("../pages/GeneralPages/AdvancedOrganizationalTitleDbacProtocol/AdvancedOrganizationalTitleDbacProtocolList"),
);
const AdvancedUserDbacProtocolList = lazy(
  () => import("../pages/GeneralPages/AdvancedUserDbacProtocol/AdvancedUserDbacProtocolList"),
);
const ChartDmacProtocolList = lazy(
  () => import("../pages/GeneralPages/ChartDmacProtocol/ChartDmacProtocolList"),
);
const NonUserDmacProtocolList = lazy(
  () => import("../pages/GeneralPages/NonUserDmacProtocol/NonUserDmacProtocolList"),
);
const OrganizationalTitleDmacProtocolList = lazy(
  () =>
    import("../pages/GeneralPages/OrganizationalTitleDmacProtocol/OrganizationalTitleDmacProtocolList"),
);
const UserDmacProtocolList = lazy(
  () => import("../pages/GeneralPages/UserDmacProtocol/UserDmacProtocolList"),
);
const OperationList = lazy(() => import("../pages/GeneralPages/Operation/OperationList"));
const OperationAllList = lazy(() => import("../pages/GeneralPages/OperationAll/OperationAllList"));
const EntityList = lazy(() => import("../pages/GeneralPages/Entity/List"));
const TaskList = lazy(() => import("../pages/GeneralPages/Task/List"));
const GeneralUserList = lazy(() => import("../pages/GeneralPages/GeneralUser/List"));
const GeneralUserV2List = lazy(() => import("../pages/GeneralPages/GeneralUserV2/List"));
const EnumDefinitionList = lazy(() => import("../pages/GeneralPages/EnumDefinition/List"));
const UserGroupList = lazy(() => import("../pages/GeneralPages/UserGroup/List"));
const ProcessFlowList = lazy(() => import("../pages/GeneralPages/ProcessFlow/List"));
const ProcessVersionList = lazy(() => import("../pages/GeneralPages/ProcessVersion/List"));
const AccountList = lazy(() => import("../pages/PACPages/Account/List"));
const AccountInputList = lazy(() => import("../pages/PACPages/AccountInput/List"));
const PosList = lazy(() => import("../pages/PACPages/Pos/List"));
const PosInputList = lazy(() => import("../pages/PACPages/PosInput/List"));
const BranchList = lazy(() => import("../pages/PACPages/Branch/List"));
const StaffDefinerOfSaleDepartmentChartList = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfSaleDepartmentChart/List"),
);
const StaffDefinerOfSaleDepartmentStaffList = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfSaleDepartmentStaff/List"),
);
const StaffDefinerOfLogisticDepartmentChartList = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfLogisticDepartmentChart/List"),
);
const StaffDefinerOfLogisticDepartmentStaffList = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfLogisticDepartmentStaff/List"),
);
const StaffDefinerOfFinancialDepartmentChartList = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfFinancialDepartmentChart/List"),
);
const StaffDefinerOfFinancialDepartmentStaffList = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfFinancialDepartmentStaff/List"),
);
const CollectorChartList = lazy(() => import("../pages/PACPages/CollectorChart/List"));
const CollectorStaffList = lazy(() => import("../pages/PACPages/CollectorStaff/List"));
const TreasurerChartList = lazy(() => import("../pages/PACPages/TreasurerChart/List"));
const TreasurerStaffList = lazy(() => import("../pages/PACPages/TreasurerStaff/List"));
const CollectionPipelineList = lazy(() => import("../pages/PACPages/CollectionPipeline/List"));
const PosAllocationList = lazy(() => import("../pages/PACPages/PosAllocation/List"));
const LicenseInfoList = lazy(() => import("../pages/PAVPages/LicenseInfo/List"));
const BankAccountGroupList = lazy(() => import("../pages/PACPages/BankAccountGroup/List"));
const SuperAdminChartList = lazy(() => import("../pages/GeneralPages/SuperAdminChart/List"));
const SuperAdminStaffList = lazy(() => import("../pages/GeneralPages/SuperAdminStaff/List"));
const SoftwareAdminChartList = lazy(() => import("../pages/GeneralPages/SoftwareAdminChart/List"));
const ChartAndAuxiliaryAdminChartList = lazy(
  () => import("../pages/GeneralPages/ChartAndAuxiliaryAdminChart/List"),
);
const ChartAndAuxiliaryAdminStaffList = lazy(
  () => import("../pages/GeneralPages/ChartAndAuxiliaryAdminStaff/List"),
);
const ProcessAdminChartList = lazy(() => import("../pages/GeneralPages/ProcessAdminChart/List"));
const ProcessAdminStaffList = lazy(() => import("../pages/GeneralPages/ProcessAdminStaff/List"));
const RegulatoryChartList = lazy(() => import("../pages/PAVPages/RegulatoryChart/List"));
const RegulatoryStaffList = lazy(() => import("../pages/PAVPages/RegulatoryStaff/List"));
const SoftwareAdminStaffList = lazy(() => import("../pages/GeneralPages/SoftwareAdminStaff/List"));
const BusinessUnitList = lazy(() => import("../pages/BINFPages/BusinessUnit/List"));
const PersonList = lazy(() => import("../pages/BINFPages/Person/List"));
// const OfficeList = lazy(() => import("../pages/BINFPages/Office/List"));
const OfficeList = lazy(() => import("../pages/BINFPages/OfficeV1/List"));
const GeneralDacProtocolList = lazy(() => import("../pages/GeneralPages/GeneralDacProtocol/List"));
const DbacDmacCandidates = lazy(
  () => import("../pages/GeneralPages/DbacDmacCandidates/DbacDmacCandidates"),
);
const CustomerReceivableResolutionList = lazy(
  () => import("../pages/MLM/CustomerReceivableResolution/List"),
);
const AccountingDocumentList = lazy(() => import("../pages/Financial/AccountingDocument/List"));
const BeautyAdvisorSupervisionChartList = lazy(
  () => import("../pages/MLM/BeautyAdvisorSupervisionChart/List"),
);
const SrmHrChartList = lazy(() => import("../pages/MLM/SrmHrChart/List"));
const SrmSoftwareSupportChartList = lazy(() => import("../pages/MLM/SrmSoftwareSupportChart/List"));
const BeautyAdvisorSupervisionSectorList = lazy(
  () => import("../pages/MLM/BeautyAdvisorSupervisionSector/List"),
);
const SaleSupportGeoDivisionSectorList = lazy(
  () => import("../pages/MLM/SaleSupportGeoDivisionSector/List"),
);
// ========== hcm
const JobPositionList = lazy(() => import("../pages/HCM/JobPosition/List"));
const HrSegmentList = lazy(() => import("../pages/HCM/HrSegment/List"));
const InterviewSchedulingAndReschedulingList = lazy(
  () => import("../pages/HCM/InterviewSchedulingAndRescheduling/List"),
);
const CandidateScreeningList = lazy(() => import("../pages/HCM/CandidateScreening/List"));
const CognitiveTestQuestionList = lazy(() => import("../pages/HCM/CognitiveTestQuestion/List"));
const CandidateAssessmentList = lazy(() => import("../pages/HCM/CandidateAssessment/List"));
const HiringList = lazy(() => import("../pages/HCM/Hiring/List"));
const DocumentSubmissionSchedulingList = lazy(
  () => import("../pages/HCM/DocumentSubmissionScheduling/List"),
);
const CandidateSelectionList = lazy(() => import("../pages/HCM/CandidateSelectionV1/List"));
const GsmMessageLogList = lazy(() => import("../pages/GSM/GsmMessageLog/List"));
const DelegationByMe = lazy(() => import("../pages/Delegation/GivenByMe/List"));
const DelegatedToMe = lazy(() => import("../pages/Delegation/GivenToMe/List"));
const GsmRoutingList = lazy(() => import("../pages/GSM/GsmRouting/List"));
//====== Correspondence
const CorrespondenceInboxList = lazy(() => import("../pages/Correspondence/MessagesInbox/List"));
// const CorrespondenceSentList = lazy(() => import("../pages/Correspondence/Sent/List"));
// const CorrespondenceDraftList = lazy(() => import("../pages/Correspondence/Draft/List"));

const adminPanelListRoutes = [
  // ========================================================= ***AccountParty** =========================================================
  {
    entityName: "AccountParty",
    packageName: "onlineShopPortal",
    path: "/account-party",
    element: <AccountPartyList />,
  },
  // ========================================================= ***Brand** =========================================================
  {
    entityName: "Brand",
    packageName: "onlineShopPortal",
    path: "/brand",
    element: <BrandList />,
  },
  // ========================================================= ***Cargo** =========================================================
  {
    entityName: "Cargo",
    packageName: "onlineShopPortal",
    path: "/cargo",
    element: <CargoList />,
  },
  // ========================================================= ***CustomerCandidate** =========================================================
  {
    entityName: "CustomerCandidate",
    packageName: "onlineShopPortal",
    path: "/customer-candidate",
    element: <CustomerCandidateList />,
  },
  // ========================================================= ***Discount** =========================================================
  {
    entityName: "Discount",
    packageName: "onlineShopPortal",
    path: "/discount",
    element: <DiscountList />,
  },
  // // ========================================================= ***PKU** =========================================================
  // {
  //   entityName: "PKU",
  //   packageName: "onlineShopPortal",
  //
  //   path: "/pku",
  //   element: <PKUList />,
  // },
  // ========================================================= ***Price** =========================================================
  {
    entityName: "SkuSeller",
    packageName: "mlm",
    path: "/prices",
    element: <PricesList />,
  },
  // // ========================================================= ***ProductGroup** =========================================================
  // {
  //   entityName: "ProductGroup",
  //   packageName: "onlineShopPortal",
  //
  //   path: "/product-group",
  //   element: <ProductGroupList />,
  // },
  // ========================================================= ***Response** =========================================================
  {
    entityName: "Replay",
    packageName: "onlineShopPortal",
    path: "/response",
    element: <ResponseList />,
  },
  // ========================================================= ***SalePack** =========================================================
  {
    entityName: "SalePack",
    packageName: "onlineShopPortal",
    path: "/sale-pack",
    element: <SalePackList />,
  },
  // ========================================================= ***SellingProduct** =========================================================
  {
    entityName: "SellingProduct",
    packageName: "onlineShopPortal",
    path: "/selling-product",
    element: <SellingProductList />,
  },
  // ========================================================= ***SKU** =========================================================
  {
    entityName: "Sku",
    packageName: "onlineShopPortal",
    path: "/sku",
    element: <SkuList />,
  },
  // ========================================================= ***SKU-Edit** =========================================================
  {
    entityName: "SkuEdit",
    packageName: "onlineShopPortal",
    path: "/sku-edit",
    element: <SkuEditList />,
  },
  // ========================================================= ***PKU** =========================================================
  {
    entityName: "Pku",
    packageName: "onlineShopPortal",
    path: "/pku",
    element: <PkuList />,
  },
  // ========================================================= ***PKU-Edit** =========================================================
  {
    entityName: "PkuEdit",
    packageName: "onlineShopPortal",
    path: "/pku-edit",
    element: <PkuEditList />,
  },
  // ========================================================= ***WarehouseGroup** =========================================================
  {
    entityName: "WarehouseGroup",
    packageName: "onlineShopPortal",
    path: "/warehouse-group",
    element: <WarehouseGroupList />,
  },
  // ========================================================= ***WarehouseNote** =========================================================
  {
    entityName: "WarehouseNote",
    packageName: "onlineShopPortal",
    path: "/warehouse-note",
    element: <WarehouseNoteList />,
  },
  // ========================================================= ***ProductNature** =========================================================
  {
    entityName: "ProductNature",
    packageName: "onlineShopPortal",
    path: "/product-nature",
    element: <ProductNatureList />,
  },
  // ========================================================= ***MeasurementUnit** =========================================================
  {
    entityName: "MeasurementUnit",
    packageName: "onlineShopPortal",
    path: "/measurement-unit",
    element: <MeasurementUnitList />,
  },
  // ========================================================= ***UIDP** =========================================================
  {
    entityName: "UIDP",
    packageName: "onlineShopPortal",
    path: "/uidp",
    element: <UIDPList />,
  },
  // ========================================================= ***User** =========================================================
  {
    entityName: "User",
    packageName: "onlineShopPortal",
    path: "/user",
    element: <UserList />,
  },
  // ========================================================= ***Warehouse** =========================================================
  {
    entityName: "Warehouse",
    packageName: "onlineShopPortal",
    path: "/warehouse",
    element: <WarehouseList />,
  },
  // ========================================================= ***WarehouseOperation** =========================================================
  {
    entityName: "WarehouseOperation",
    packageName: "onlineShopPortal",
    path: "/warehouse-operation",
    element: <WarehouseOperationList />,
  },
];
const pacChartsAndStaffsListRoutes = [
  // ========================================================= ***CollectorChart** =========================================================
  {
    entityName: "CollectorChart",
    packageName: "posAccountControl",
    path: "/posAccountControl/collector-chart",
    element: <CollectorChartList />,
  },
  // ========================================================= ***CollectorStaff** =========================================================
  {
    entityName: "CollectorStaff",
    packageName: "posAccountControl",
    path: "/posAccountControl/collector-staff",
    element: <CollectorStaffList />,
  },
  // ========================================================= ***TreasurerChart** =========================================================
  {
    entityName: "TreasurerChart",
    packageName: "posAccountControl",
    path: "/posAccountControl/treasurer-chart",
    element: <TreasurerChartList />,
  },
  // ========================================================= ***TreasurerStaff** =========================================================
  {
    entityName: "TreasurerStaff",
    packageName: "posAccountControl",
    path: "/posAccountControl/treasurer-staff",
    element: <TreasurerStaffList />,
  },
];
const ospChartsAndStaffsListRoutes = [
  // ========================================================= ***SaleChart** =========================================================
  {
    entityName: "SalePersonChart",
    packageName: "onlineShopPortal",
    path: "/sale-person-chart",
    element: <SaleChartList />,
  },
  // ========================================================= ***SaleStaff** =========================================================
  {
    entityName: "SalePersonStaff",
    packageName: "onlineShopPortal",
    path: "/sale-person-staff",
    element: <SaleStaffList />,
  },
  // ========================================================= ***LogisticChart** =========================================================
  // {
  //   entityName: "LogisticChart",
  //   packageName: "onlineShopPortal",
  //
  //   path: "/logistic-chart",
  //   element: <LogisticChartList />,
  // },
  // ========================================================= ***LogisticStaff** =========================================================
  {
    entityName: "LogisticStaff",
    packageName: "onlineShopPortal",
    path: "/logistic-staff",
    element: <LogisticStaffList />,
  },
  // ========================================================= ***ChiefManagementChart** =========================================================
  {
    entityName: "ChiefManagementChart",
    packageName: "onlineShopPortal",
    path: "/chief-management-chart",
    element: <ChiefManagementChartList />,
  },
  // ========================================================= ***ChiefManagementStaff** =========================================================
  {
    entityName: "ChiefManagementStaff",
    packageName: "onlineShopPortal",
    path: "/chief-management-staff",
    element: <ChiefManagementStaffList />,
  },
];
const generalChartsAndStaffsListRoutes = [
  // ========================================================= ***SuperAdminChart** =========================================================
  {
    entityName: "SuperAdminChart",
    packageName: "general",
    path: "/super-admin-chart",
    element: <SuperAdminChartList />,
  },
  // ========================================================= ***SuperAdminStaff** =========================================================
  {
    entityName: "SuperAdminStaff",
    packageName: "general",
    path: "/super-admin-staff",
    element: <SuperAdminStaffList />,
  },
  // ========================================================= ***ChartAndAuxiliaryAdminChart** =========================================================
  {
    entityName: "ChartAndAuxiliaryAdminChart",
    packageName: "general",
    path: "/chart-and-auxiliary-admin-chart",
    element: <ChartAndAuxiliaryAdminChartList />,
  },
  // ========================================================= ***ChartAndAuxiliaryAdminStaff** =========================================================
  {
    entityName: "ChartAndAuxiliaryAdminStaff",
    packageName: "general",
    path: "/chart-and-auxiliary-admin-staff",
    element: <ChartAndAuxiliaryAdminStaffList />,
  },
  // ========================================================= ***ProcessAdminChart** =========================================================
  {
    entityName: "ProcessAdminChart",
    packageName: "general",
    path: "/process-admin-chart",
    element: <ProcessAdminChartList />,
  },
  // ========================================================= ***ProcessAdminStaff** =========================================================
  {
    entityName: "ProcessAdminStaff",
    packageName: "general",
    path: "/process-admin-staff",
    element: <ProcessAdminStaffList />,
  },
  // ========================================================= ***SoftwareAdminChart** =========================================================
  {
    entityName: "SoftwareAdminChart",
    packageName: "general",
    path: "/software-admin-chart",
    element: <SoftwareAdminChartList />,
  },

  // ========================================================= ***SoftwareAdminStaff** =========================================================
  {
    entityName: "SoftwareAdminStaff",
    packageName: "general",
    path: "/software-admin-staff",
    element: <SoftwareAdminStaffList />,
  },
  // ========================================================= ***StaffDefinerOfFinancialDepartmentChart** =========================================================
  {
    entityName: "StaffDefinerOfFinancialDepartmentChart",
    packageName: "general",
    path: "/staff-definer-of-financial-department-chart",
    element: <StaffDefinerOfFinancialDepartmentChartList />,
  },
  // ========================================================= ***StaffDefinerOfFinancialDepartmentStaff** =========================================================
  {
    entityName: "StaffDefinerOfFinancialDepartmentStaff",
    packageName: "general",
    path: "/staff-definer-of-financial-department-staff",
    element: <StaffDefinerOfFinancialDepartmentStaffList />,
  },
  // ========================================================= ***StaffDefinerOfLogisticDepartmentChart** =========================================================
  {
    entityName: "StaffDefinerOfLogisticDepartmentChart",
    packageName: "general",
    path: "/staff-definer-of-logistic-department-chart",
    element: <StaffDefinerOfLogisticDepartmentChartList />,
  },
  // ========================================================= ***StaffDefinerOfLogisticDepartmentStaff** =========================================================
  {
    entityName: "StaffDefinerOfLogisticDepartmentStaff",
    packageName: "general",
    path: "/staff-definer-of-logistic-department-staff",
    element: <StaffDefinerOfLogisticDepartmentStaffList />,
  },
  // ========================================================= ***StaffDefinerOfSaleDepartmentChart** =========================================================
  {
    entityName: "StaffDefinerOfSaleDepartmentChart",
    packageName: "general",
    path: "/staff-definer-of-sale-department-chart",
    element: <StaffDefinerOfSaleDepartmentChartList />,
  },
  // ========================================================= ***StaffDefinerOfSaleDepartmentStaff** =========================================================
  {
    entityName: "StaffDefinerOfSaleDepartmentStaff",
    packageName: "general",
    path: "/staff-definer-of-sale-department-staff",
    element: <StaffDefinerOfSaleDepartmentStaffList />,
  },
];
const dbacDmacListRoutes = [
  // ========================================================= ***AdvancedChartDbacProtocol** =========================================================
  {
    entityName: "AdvancedChartDbacProtocol",
    packageName: "general",
    path: "/chart-dbac",
    element: <AdvancedChartDbacProtocolList />,
  },
  // ========================================================= ***AdvancedNonUserDbacProtocol** =========================================================
  {
    entityName: "AdvancedNonUserDbacProtocol",
    packageName: "general",
    path: "/non-user-dbac",
    element: <AdvancedNonUserDbacProtocolList />,
  },
  // ========================================================= ***AdvancedOrganizationalTitleDbacProtocol** =========================================================
  {
    entityName: "AdvancedOrganizationalTitleDbacProtocol",
    packageName: "general",
    path: "/organizational-title-dbac",
    element: <AdvancedOrganizationalTitleDbacProtocolList />,
  },
  // ========================================================= ***AdvancedUserDbacProtocol** =========================================================
  {
    entityName: "AdvancedUserDbacProtocol",
    packageName: "general",
    path: "/user-dbac",
    element: <AdvancedUserDbacProtocolList />,
  },
  // ========================================================= ***ChartDmacProtocol** =========================================================
  {
    entityName: "ChartDmacProtocol",
    packageName: "general",
    path: "/chart-dmac",
    element: <ChartDmacProtocolList />,
  },
  // ========================================================= ***NonUserDmacProtocol** =========================================================
  {
    entityName: "NonUserDmacProtocol",
    packageName: "general",
    path: "/non-user-dmac",
    element: <NonUserDmacProtocolList />,
  },
  // ========================================================= ***OrganizationalTitleDmacProtocol** =========================================================
  {
    entityName: "OrganizationalTitleDmacProtocol",
    packageName: "general",
    path: "/organizational-title-dmac",
    element: <OrganizationalTitleDmacProtocolList />,
  },
  // ========================================================= ***UserDmacProtocol** =========================================================
  {
    entityName: "UserDmacProtocol",
    packageName: "general",
    path: "/user-dmac",
    element: <UserDmacProtocolList />,
  },
];
const adminGeneralRoutes = [
  // ========================================================= *** Operation *** =========================================================
  {
    entityName: "Operation",
    packageName: "general",
    path: "/operation",
    element: <OperationList />,
  },
  // ========================================================= *** Operation *** =========================================================
  {
    entityName: "Operation",
    packageName: "general",
    path: "/all",
    element: <OperationAllList />,
  },
  // ========================================================= *** Task *** =========================================================
  {
    entityName: "Task",
    packageName: "general",
    path: "/task",
    element: <TaskList />,
  },
  // ========================================================= *** User *** =========================================================
  {
    entityName: "User",
    packageName: "general",
    path: "/general/user",
    element: <GeneralUserList />,
  },
  // ========================================================= *** UserV2 *** =========================================================
  {
    entityName: "User",
    packageName: "general",
    path: "/general/userV2",
    element: <GeneralUserV2List />,
  },
  // ========================================================= *** UserV2 *** =========================================================
  {
    entityName: "User",
    // entityName: "EnumDefinition",
    packageName: "general",
    path: "/general/enum-definition",
    element: <EnumDefinitionList />,
  },
  // ========================================================= *** UserGroup *** =========================================================
  {
    entityName: "UserGroup",
    packageName: "general",
    path: "/general/user-group",
    element: <UserGroupList />,
  },
  // ========================================================= *** ProcessFlow *** =========================================================
  {
    entityName: "ProcessFlow",
    packageName: "general",
    path: "/process-flow",
    element: <ProcessFlowList />,
  },
  // ========================================================= *** ProcessVersion *** =========================================================
  {
    entityName: "ProcessVersion",
    packageName: "general",
    path: "/process-version",
    element: <ProcessVersionList />,
  },
  // ========================================================= *** DBAC DMAC CANDIDATES *** =========================================================
  {
    entityName: "Package",
    packageName: "general",
    path: "/dbac-dmac-candidates",
    element: <DbacDmacCandidates />,
  },
  {
    entityName: "Package",
    packageName: "general",
    path: "/dbac-dmac-candidates/:packageId/:packageName",
    element: <DbacDmacCandidates />,
  },
  // ========================================================= *** GeneralDacProtocol *** =========================================================
  {
    entityName: "GeneralDacProtocol",
    packageName: "general",
    path: "/general-dac-protocol",
    element: <GeneralDacProtocolList />,
  },
  {
    entityName: "GeneralDacProtocol",
    packageName: "general",
    path: "/general-dac-protocol/:entityId/:entityName",
    element: <GeneralDacProtocolList />,
  },
  // ========================================================= *** ENTITY ACCESS GRANTS *** =========================================================
  {
    entityName: "EntityConfig",
    packageName: "baseKit",
    path: "/general/entity-config",
    element: <EntityAccessGrantsList />,
  },

  // ========================================================= *** FORM SUPPORT ACCESS GRANTS *** =========================================================
  {
    entityName: "EntityConfig",
    packageName: "baseKit",
    path: "/form-support",
    element: <FormSupportGenerator />,
  },
  // ========================================================= *** FIELD ACCESS GRANTS *** =========================================================
  {
    entityName: "FieldConfig",
    packageName: "baseKit",
    path: "/general/field-config",
    element: <FieldAccessGrantsList />,
  },
];
const adminPacRoutes = [
  // ========================================================= *** Account *** =========================================================
  {
    entityName: "BankAccount",
    packageName: "posAccountControl",
    path: "/posAccountControl/bank-account",
    element: <AccountList />,
  },
  // ========================================================= *** Account *** =========================================================
  {
    entityName: "BankAccountGroup",
    packageName: "posAccountControl",
    path: "/posAccountControl/bank-account-group",
    element: <BankAccountGroupList />,
  },
  // ========================================================= *** AccountInput *** =========================================================
  {
    entityName: "BankAccountInput",
    packageName: "posAccountControl",
    path: "/posAccountControl/bank-account-input",
    element: <AccountInputList />,
  },
  // ========================================================= *** Pos *** =========================================================
  {
    entityName: "PosDevice",
    packageName: "posAccountControl",
    path: "/posAccountControl/pos-device",
    element: <PosList />,
  },
  // ========================================================= *** PosInput *** =========================================================
  {
    entityName: "PosInput",
    packageName: "posAccountControl",
    path: "/posAccountControl/pos-input",
    element: <PosInputList />,
  },
  // ========================================================= *** Branch *** =========================================================
  {
    entityName: "Branch",
    packageName: "posAccountControl",
    path: "/posAccountControl/branch",
    element: <BranchList />,
  },
  // ========================================================= *** CollectionPipeline *** =========================================================
  {
    entityName: "CollectionPipeline",
    packageName: "posAccountControl",
    path: "/posAccountControl/collection-pipeline",
    element: <CollectionPipelineList />,
  },
  // ========================================================= *** PosAllocation *** =========================================================
  {
    entityName: "PosAllocation",
    packageName: "posAccountControl",
    path: "/posAccountControl/pos-allocation",
    element: <PosAllocationList />,
  },
];
const adminPavRoutes = [
  // ========================================================= *** LicenseInfo *** =========================================================
  {
    entityName: "LicenseInfo",
    packageName: "productAuthenticityVerification",
    path: "/productAuthenticityVerification/license-info",
    element: <LicenseInfoList />,
  },
  // ========================================================= *** RegulatoryChart *** =========================================================
  {
    entityName: "RegulatoryChart",
    packageName: "productAuthenticityVerification",
    path: "/productAuthenticityVerification/regulatory-chart",
    element: <RegulatoryChartList />,
  },
  // ========================================================= *** RegulatoryStaff *** =========================================================
  {
    entityName: "RegulatoryStaff",
    packageName: "productAuthenticityVerification",
    path: "/productAuthenticityVerification/regulatory-staff",
    element: <RegulatoryStaffList />,
  },
];
const marketVisitRoutes = [
  // ========================================================= *** LicenseInfo *** =========================================================
  {
    entityName: "BankAccount",
    packageName: "posAccountControl",
    path: "/marketVisit/SupervisorMarketVisit",
    element: <SupervisorMarketVisitList />,
  },
];
const saleRepresentativesRoutes = [
  // ========================================================= *** SrmSoftwareSupportChart *** =========================================================
  {
    entityName: "SrmSoftwareSupportChart",
    packageName: "saleRepresentatives",
    key: Math.ceil(Math.random()) * 100000,
    path: "/srm-software-support-chart",
    element: <SrmSoftwareSupportChartList />,
  },
  // ========================================================= *** SrmHrChart *** =========================================================
  {
    entityName: "SrmHrChart",
    packageName: "saleRepresentatives",
    key: Math.ceil(Math.random()) * 100000,
    path: "/srm-hr-chart",
    element: <SrmHrChartList />,
  },
  // ========================================================= *** BeautyAdvisorSupervisionChart *** =========================================================
  {
    entityName: "BeautyAdvisorSupervisionChart",
    packageName: "saleRepresentatives",
    key: Math.ceil(Math.random()) * 100000,
    path: "/beauty-advisor-supervision-chart",
    element: <BeautyAdvisorSupervisionChartList />,
  },
  // ========================================================= *** SaleSupportGeoDivisionSector *** =========================================================
  {
    entityName: "SaleSupportGeoDivisionSector",
    packageName: "saleRepresentatives",
    key: Math.ceil(Math.random()) * 100000,
    path: "/sale-support-geo-division-sector",
    element: <SaleSupportGeoDivisionSectorList />,
  },
  // ========================================================= *** BeautyAdvisorSupervisionSector *** =========================================================
  {
    entityName: "BeautyAdvisorSupervisionSector",
    packageName: "saleRepresentatives",
    key: Math.ceil(Math.random()) * 100000,
    path: "/beauty-advisor-supervision-sector",
    element: <BeautyAdvisorSupervisionSectorList />,
  },
  // ========================================================= *** BeautyAdvisorReport *** =========================================================
  {
    entityName: "BeautyAdvisorReport",
    packageName: "saleRepresentatives",
    path: "/beauty-advisor-report",
    element: <BeautyAdvisorReportList />,
  },
  // ========================================================= *** LicenseInfo *** =========================================================
  {
    entityName: "SaleRepresentative",
    packageName: "saleRepresentatives",
    path: "/sale-representative",
    element: <SaleRepresentativeList />,
  },
  // ========================================================= *** PointOfSale *** =========================================================
  {
    entityName: "PointOfSale",
    packageName: "saleRepresentatives",
    path: "/point-of-sale",
    element: <PointOfSaleList />,
  },
  // ========================================================= *** UserInformation *** =========================================================
  {
    entityName: "UserInformation",
    packageName: "saleRepresentatives",
    path: "/user-information",
    element: <UserInformationList />,
  },
  // ========================================================= *** BeautyAdvisorChart *** =========================================================
  {
    entityName: "BeautyAdvisorChart",
    packageName: "saleRepresentatives",
    path: "/beauty-advisor-chart",
    element: <BeautyAdvisorChartList />,
  },
  // ========================================================= *** BeautyAdvisorSupervisorReport *** =========================================================
  {
    entityName: "BeautyAdvisorSupervisorReport",
    packageName: "saleRepresentatives",
    path: "/beauty-advisor-supervisor-report",
    element: <BeautyAdvisorSupervisorReportList />,
  },
];
const hrinfRoutes = [
  // ========================================================= *** jobApply *** =========================================================
  {
    entityName: "JobApply",
    packageName: "hrinf",
    path: "/job-apply",
    element: <ApplicantInformationList />,
  },
  // ========================================================= *** jobApply *** =========================================================
  {
    entityName: "AdministrativeAffairsChart",
    packageName: "hcm",
    path: "/administrative-affairs-chart",
    element: <AdministrativeAffairsChartList />,
  },
  // ========================================================= *** jobApply *** =========================================================
  {
    entityName: "HrAdminChart",
    packageName: "hcm",
    path: "/hr-admin-chart",
    element: <HrAdminChartList />,
  },
  // ========================================================= *** Corporate Chart *** =========================================================
  {
    entityName: "CorporateChart",
    packageName: "hcm",
    path: "/corporate-chart",
    element: <CorporateChartList />,
  },
  // ========================================================= *** Corporate Staff *** =========================================================
  {
    entityName: "CorporateStaff",
    packageName: "hcm",
    path: "/corporate-staff",
    element: <CorporateStaffList />,
  },
  // ========================================================= *** PersonnelDocumentDigitization *** =========================================================
  {
    entityName: "PersonnelDocumentDigitization",
    packageName: "hrinf",
    path: "/personnel-document-digitization",
    element: <PddList />,
  },
  // ========================================================= *** OrganizationalTitleSalaryDifference *** =========================================================
  {
    entityName: "OrganizationalTitleSalaryDifference",
    packageName: "hrinf",
    path: "/hrinf/organizational-title-salary-difference",
    element: <OrganizationalTitleSalaryDifferenceList />,
  },
  // ========================================================= *** NationalCodeCellphoneOfPersonnel *** =========================================================
  {
    entityName: "NationalCodeCellphoneOfPersonnel",
    packageName: "hrinf",
    path: "/hrinf/national-code-of-personnel",
    element: <NationalCodeCellphoneOfPersonnelList />,
  },
];

const binfRoutes = [
  // ========================================================= ***BusinessUnit** =========================================================
  {
    entityName: "BusinessUnit",
    packageName: "binf",
    path: "/binf/business-unit",
    element: <BusinessUnitList />,
  },
  // ========================================================= ***BusinessUnit** =========================================================
  {
    entityName: "BuAndOfficeAdminChart",
    packageName: "binf",
    path: "/bu-and-office-admin-chart",
    element: <BuAndOfficeAdminChartList />,
  },
  // ========================================================= ***Office** =========================================================
  {
    entityName: "Office",
    packageName: "binf",
    path: "/binf/office",
    element: <OfficeList />,
  },
  // ========================================================= ***Person** =========================================================
  {
    entityName: "Person",
    packageName: "binf",
    path: "/binf/person",
    element: <PersonList />,
  },
  // ========================================================= *** ORGANIZATIONAL TITLE *** =========================================================
  {
    entityName: "OrganizationalTitle",
    packageName: "binf",
    path: "/organizational-title",
    element: <OrganizationalTitleList />,
  },
  // ========================================================= *** ORGANIZATIONAL TITLE GROUP *** =========================================================
  {
    entityName: "OrganizationalTitleGroup",
    packageName: "binf",
    path: "/organizational-title-group",
    element: <OrganizationalTitleGroupList />,
  },
  // ========================================================= *** ORGANIZATIONAL LEVEL *** =========================================================
  {
    entityName: "OrganizationalLevel",
    packageName: "binf",
    path: "/organizational-level",
    element: <OrganizationalLevelList />,
  },
  // ========================================================= *** Entity *** =========================================================
  {
    entityName: "Entity",
    packageName: "binf",
    path: "/entity",
    element: <EntityList />,
  },
  // ========================================================= ***EducationalInstitute** =========================================================
  // {
  //   entityName: "EducationalInstitute",
  //   packageName: "hrinf",
  //
  //   path: "/educational-institute",
  //   element: (
  //     <EducationalInstituteList
  //       canEdit={hasAccess("hrinf", "EducationalInstitute", "edit")}
  //       canAdd={hasAccess("hrinf", "EducationalInstitute", "add")}
  //       canDelete={hasAccess("hrinf", "EducationalInstitute", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***contract** =========================================================
  // {
  //   entityName: "Contract",
  //   packageName: "hrinf",
  //
  //   path: "/contract",
  //   element: (
  //     <ContractList
  //       canEdit={hasAccess("hrinf", "Contract", "edit")}
  //       canAdd={hasAccess("hrinf", "Contract", "add")}
  //       canDelete={hasAccess("hrinf", "Contract", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Major** =========================================================
  // {
  //   entityName: "Major",
  //   packageName: "hrinf",
  //
  //   path: "/major",
  //   element: (
  //     <MajorList
  //       canEdit={hasAccess("hrinf", "Major", "edit")}
  //       canAdd={hasAccess("hrinf", "Major", "add")}
  //       canDelete={hasAccess("hrinf", "Major", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***UNDER POSSESIONS** =========================================================
  // {
  //   entityName: "BURelation",
  //   packageName: "binf",
  //
  //   path: "/under-possesion",
  //   element: (
  //     <UnderPossesionList
  //       canEdit={hasAccess("binf", "BURelation", "edit")}
  //       canAdd={hasAccess("binf", "BURelation", "add")}
  //       canDelete={hasAccess("binf", "BURelation", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Shareholders** =========================================================
  // {
  //   entityName: "BURelation",
  //   packageName: "binf",
  //
  //   path: "/shareholder",
  //   element: (
  //     <ShareHolderList
  //       canEdit={hasAccess("binf", "BURelation", "edit")}
  //       canAdd={hasAccess("binf", "BURelation", "add")}
  //       canDelete={hasAccess("binf", "BURelation", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***OfficeType** =========================================================
  // {
  //   entityName: "OfficeType",
  //   packageName: "binf",
  //
  //   path: "/office-type",
  //   element: (
  //     <OfficeTypeList
  //       canEdit={hasAccess("binf", "OfficeType", "edit")}
  //       canAdd={hasAccess("binf", "OfficeType", "add")}
  //       canDelete={hasAccess("binf", "OfficeType", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***AddressType** =========================================================
  // {
  //   entityName: "AddressType",
  //   packageName: "binf",
  //
  //   path: "/address-type",
  //   element: (
  //     <AddressTypeList
  //       canEdit={hasAccess("binf", "AddressType", "edit")}
  //       canAdd={hasAccess("binf", "AddressType", "add")}
  //       canDelete={hasAccess("binf", "AddressType", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Contact info Type** =========================================================
  // {
  //   entityName: "ContactInfoType",
  //   packageName: "binf",
  //
  //   path: "/contact-info-type",
  //   element: (
  //     <ContactInfoTypeList
  //       canEdit={hasAccess("binf", "ContactInfoType", "edit")}
  //       canAdd={hasAccess("binf", "ContactInfoType", "add")}
  //       canDelete={hasAccess("binf", "ContactInfoType", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Organization** =========================================================
  // {
  //   entityName: "Organization",
  //   packageName: "binf",
  //
  //   path: "/organization",
  //   element: (
  //     <OrganizationList
  //       canEdit={hasAccess("binf", "Organization", "edit")}
  //       canAdd={hasAccess("binf", "Organization", "add")}
  //       canDelete={hasAccess("binf", "Organization", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Organization Tag** =========================================================
  // {
  //   entityName: "OrganizationTag",
  //   packageName: "binf",
  //
  //   path: "/organization-tag",
  //   element: (
  //     <OrganizationTagList
  //       canEdit={hasAccess("binf", "OrganizationTag", "edit")}
  //       canAdd={hasAccess("binf", "OrganizationTag", "add")}
  //       canDelete={hasAccess("binf", "OrganizationTag", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Occasions** =========================================================
  // {
  //   entityName: "AnnualOccasion",
  //   packageName: "binf",
  //
  //   path: "/annual-occasion",
  //   element: (
  //     <AnnualOccasionList
  //       canEdit={hasAccess("binf", "AnnualOccasion", "edit")}
  //       canAdd={hasAccess("binf", "AnnualOccasion", "add")}
  //       canDelete={hasAccess("binf", "AnnualOccasion", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Weekly Holidays** =========================================================
  // {
  //   entityName: "WeeklyHoliday",
  //   packageName: "binf",
  //
  //   path: "/weekly-holiday",
  //   element: (
  //     <WeeklyHolidayList
  //       canEdit={hasAccess("binf", "WeeklyHoliday", "edit")}
  //       canAdd={hasAccess("binf", "WeeklyHoliday", "add")}
  //       canDelete={hasAccess("binf", "WeeklyHoliday", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= *** City ** =========================================================
  // {
  //   entityName: "City",
  //   packageName: "binf",
  //
  //   path: "/city",
  //   element: (
  //     <CityList
  //       canEdit={hasAccess("binf", "City", "edit")}
  //       canAdd={hasAccess("binf", "City", "add")}
  //       canDelete={hasAccess("binf", "City", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= *** Province ** =========================================================
  // {
  //   entityName: "Province",
  //   packageName: "binf",
  //
  //   path: "/province",
  //   element: (
  //     <ProvinceList
  //       canEdit={hasAccess("binf", "Province", "edit")}
  //       canAdd={hasAccess("binf", "Province", "add")}
  //       canDelete={hasAccess("binf", "Province", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Person Tag** =========================================================
  // {
  //   entityName: "PersonTag",
  //   packageName: "binf",
  //
  //   path: "/person-tag",
  //   element: (
  //     <PersonTagList
  //       canEdit={hasAccess("binf", "PersonTag", "edit")}
  //       canAdd={hasAccess("binf", "PersonTag", "add")}
  //       canDelete={hasAccess("binf", "PersonTag", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***ADHOC HOLIDAY** =========================================================
  // {
  //   entityName: "AdhocHoliday",
  //   packageName: "binf",
  //
  //   path: "/adhoc-holiday",
  //   element: (
  //     <AdhocHolidayList
  //       canEdit={hasAccess("binf", "AdhocHoliday", "edit")}
  //       canAdd={hasAccess("binf", "AdhocHoliday", "add")}
  //       canDelete={hasAccess("binf", "AdhocHoliday", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= ***Occasion Tag** =========================================================
  // {
  //   entityName: "AnnualOccasionTag",
  //   packageName: "binf",
  //
  //   path: "/annual-occasion-tag",
  //   element: (
  //     <AnnualOccasionTagList
  //       canEdit={hasAccess("binf", "AnnualOccasionTag", "edit")}
  //       canAdd={hasAccess("binf", "AnnualOccasionTag", "add")}
  //       canDelete={hasAccess("binf", "AnnualOccasionTag", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= *** BINF PERSON ADMIN CHART** =========================================================
  // {
  //   entityName: "BINFPersonAdminChart",
  //   packageName: "binf",
  //
  //   path: "/binf-person-admin-chart",
  //   element: (
  //     <BINFPersonAdminChartList
  //       canEdit={hasAccess("binf", "BINFPersonAdminChart", "edit")}
  //       canAdd={hasAccess("binf", "BINFPersonAdminChart", "add")}
  //       canDelete={hasAccess("binf", "BINFPersonAdminChart", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= *** BINF BUSINESS ADMIN CHART** =========================================================
  // {
  //   entityName: "BINFBusinessAdminChart",
  //   packageName: "binf",
  //
  //   path: "/binf-business-admin-chart",
  //   element: (
  //     <BINFBusinessAdminChartList
  //       canEdit={hasAccess("binf", "BINFBusinessAdminChart", "edit")}
  //       canAdd={hasAccess("binf", "BINFBusinessAdminChart", "add")}
  //       canDelete={hasAccess("binf", "BINFBusinessAdminChart", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= *** BINF PERSON ADMIN STAFF** =========================================================
  // {
  //   entityName: "BINFPersonAdminStaff",
  //   packageName: "binf",
  //
  //   path: "/binf-person-admin-staff",
  //   element: (
  //     <BINFPersonAdminStaffList
  //       canEdit={hasAccess("binf", "BINFPersonAdminStaff", "edit")}
  //       canAdd={hasAccess("binf", "BINFPersonAdminStaff", "add")}
  //       canDelete={hasAccess("binf", "BINFPersonAdminStaff", "delete")}
  //     />
  //   ),
  // },
  // // ========================================================= *** BINF BUSINESS ADMIN STAFF** =========================================================
  // {
  //   entityName: "BINFBusinessAdminStaff",
  //   packageName: "binf",
  //
  //   path: "/binf-business-admin-staff",
  //   element: (
  //     <BINFBusinessAdminStaffList
  //       canEdit={hasAccess("binf", "BINFBusinessAdminStaff", "edit")}
  //       canAdd={hasAccess("binf", "BINFBusinessAdminStaff", "add")}
  //       canDelete={hasAccess("binf", "BINFBusinessAdminStaff", "delete")}
  //     />
  //   ),
  // },
];
const marketPriceMonitorRoutes = [
  // ========================================================= *** OnlineShopReport *** =========================================================
  {
    entityName: "OnlineShopReport",
    packageName: "marketPriceMonitor",
    path: "/market-price-monitor/online-shop-report",
    element: <ApplicantInformationList />,
  },
];
const financialRoutes = [
  // ========================================================= ***PayrollChart** =========================================================
  {
    entityName: "PayrollChart",
    packageName: "financial",
    path: "/payroll-chart",
    element: <PayrollChartList />,
  },
  {
    entityName: "BudgetingChart",
    packageName: "financial",
    path: "/budgetting-chart",
    element: <BudgetingChartList />,
  },
  {
    entityName: "FinancialInfoChart",
    packageName: "financial",
    path: "/financial-info-chart",
    element: <FinancialInfoChartList />,
  },
  {
    entityName: "ProcurementChart",
    packageName: "financial",
    path: "/procurement-chart",
    element: <ProcurementChartList />,
  },
  {
    entityName: "AccountClass",
    packageName: "finf",
    path: "/account-class",
    element: <AccountClassList />,
  },
  {
    entityName: "GeneralLedgerAccount",
    packageName: "finf",
    path: "/general-ledger-account",
    element: <GeneralLedgerAccountList />,
  },
  {
    entityName: "SubsidiaryAccount",
    packageName: "finf",
    path: "/subsidiary-account",
    element: <SubsidiaryAccountList />,
  },
  {
    entityName: "BankBranch",
    packageName: "finf",
    path: "/bank-branch",
    element: <BankBranchList />,
  },
  {
    entityName: "DetailAccountGroup",
    packageName: "finf",
    path: "/detail-account-group",
    element: <DetailAccountGroupList />,
  },
  {
    entityName: "FiscalYear",
    packageName: "finf",
    path: "/fiscal-year",
    element: <FiscalYearList />,
  },
  {
    entityName: "PurchaseProforma",
    packageName: "financial",
    path: "/purchase-proforma",
    element: <PurchaseProformaList />,
  },
  {
    entityName: "PurchaseReturnProformaWithoutUid",
    packageName: "financial",
    path: "/purchase-return-proforma-without-uid",
    element: <PurchaseReturnProformaWithoutUidList />,
  },
  {
    entityName: "PurchaseInvoice",
    packageName: "financial",
    path: "/purchase-invoice",
    element: <PurchaseInvoiceList />,
  },
  {
    entityName: "AccountingDocument",
    packageName: "financial",
    path: "/accounting-document",
    element: <AccountingDocumentList />,
  },
];
const executiveRoutes = [
  // ========================================================= ***LegalChart** =========================================================
  {
    entityName: "LegalChart",
    packageName: "executive",
    path: "/legal-chart",
    element: <LegalChartList />,
  },
  {
    entityName: "SecurityChart",
    packageName: "executive",
    path: "/security-chart",
    element: <SecurityChartList />,
  },
];
const mlmRoutes = [
  // ========================================================= ***LegalChart** =========================================================
  {
    entityName: "NrmChart",
    packageName: "mlm",
    path: "/nrm-chart",
    element: <NRMChartList />,
  },
  {
    entityName: "DeliveryTariff",
    packageName: "mlm",
    path: "/delivery-tariff",
    element: <DeliveryTariffList />,
  },
  {
    entityName: "FreightBox",
    packageName: "mlm",
    path: "/freight-box",
    element: <FreightBoxList />,
  },
  {
    entityName: "ContractTerminationRequest",
    packageName: "mlm",
    path: "/contract-termination-request",
    element: <ContractTerminationRequestList />,
  },
  {
    entityName: "CategoryManagementChart",
    packageName: "mlm",
    path: "/category_management_chart",
    element: <CategoryManagementCharttList />,
  },
  {
    entityName: "SellerSupportChart",
    packageName: "mlm",
    path: "/seller-support-chart",
    element: <SellerSupportChartList />,
  },
  {
    entityName: "SaleSupportChart",
    packageName: "mlm",
    path: "/sale-support-chart",
    element: <SaleSupportChartList />,
  },
  {
    entityName: "ProductManagementChart",
    packageName: "mlm",
    path: "/product-managment-chart",
    element: <ProductManagementChartList />,
  },
  {
    entityName: "GeographicalDivision",
    packageName: "mlm",
    path: "/geographicalDivision",
    element: <GeographicalDivisionList />,
  },
  {
    entityName: "ProductCategory",
    packageName: "onlineShopPortal",
    path: "/productCategory",
    element: <ProductCategoryList />,
  },
  {
    entityName: "SpecialDiscount",
    packageName: "onlineShopPortal",
    path: "/special-discount",
    element: <SpecialDiscountList />,
  },
  {
    entityName: "DefectiveProductStatement",
    packageName: "mlm",
    path: "/defective-product-statement",
    element: <DefectiveProductStatementList />,
  },
  {
    entityName: "CustomerReceivableResolution",
    packageName: "mlm",
    path: "/customer-receivable-resolution",
    element: <CustomerReceivableResolutionList />,
  },
  {
    entityName: "SpecialDiscountOffer",
    packageName: "onlineShopPortal",
    path: "/special-discount-offer",
    element: <SpecialDiscountOfferList />,
  },
  {
    entityName: "SpecialDiscountBox",
    packageName: "onlineShopPortal",
    path: "/special-discount-box",
    element: <SpecialDiscountBoxList />,
  },
  {
    entityName: "SkuTagSubGroup",
    packageName: "onlineShopPortal",
    path: "/sku-tag-sub-group",
    element: <SkuTagSubGroupList />,
  },
  {
    entityName: "SkuTagGroup",
    packageName: "onlineShopPortal",
    path: "/sku-tag-group",
    element: <SkuTagGroupList />,
  },
  {
    entityName: "SkuTag",
    packageName: "onlineShopPortal",
    path: "/sku-tag",
    element: <SkuTagList />,
  },
  {
    entityName: "LogisticChart",
    packageName: "onlineShopPortal",
    path: "/logistic-chart",
    element: <LogisticChartList />,
  },
  {
    entityName: "WalletTransaction",
    packageName: "mlm",
    path: "/wallet",
    element: <WalletList />,
  },
  {
    entityName: "ComplaintCase",
    packageName: "mlm",
    path: "/complaint-case",
    element: <ComplaintCaseList />,
  },
  // ========================================================= ***SkuSeller** =========================================================
  {
    entityName: "SkuSeller",
    packageName: "mlm",
    path: "/sku-seller",
    element: <SkuSellerList />,
  },
  // ========================================================= ***SaleOrderReport** =================================================
  {
    entityName: "SaleOrder",
    packageName: "mlm",
    path: "/sale-order-report",
    element: <SaleOrderReportList />,
  },
  // ========================================================= ***InvoiceReport** =========================================================
  {
    entityName: "SaleOrder",
    packageName: "mlm",
    path: "/invoice-report",
    element: <InvoiceReportList />,
  },
];
const medRepRoutes = [
  // ========================================================= *** MedicalAffairsChart *** =========================================================
  {
    entityName: "MedicalAffairsChart",
    packageName: "saleRepresentatives",
    path: "/medical-affairs-chart",
    element: <MedicalAffairsChartList />,
  },
  // ========================================================= *** MedRepChart *** =========================================================
  {
    entityName: "MedRepChart",
    packageName: "saleRepresentatives",
    path: "/med-rep-chart",
    element: <MedRepChartList />,
  },
  // ========================================================= *** SrmStockManagementChart *** =========================================================
  {
    entityName: "SrmStockManagementChart",
    packageName: "saleRepresentatives",
    path: "/srm-stock-management-chart",
    element: <SrmStockManagementChartList />,
  },
  // ========================================================= *** StockableObjectManagementChart *** =========================================================
  {
    entityName: "StockableObjectManagementChart",
    packageName: "saleRepresentatives",
    path: "/stockable-object-management-chart",
    element: <StockableObjectManagementChartList />,
  },
];
const hcmRoutes = [
  // =============================== ***JobPosition** ==========================
  {
    entityName: "JobPosition",
    packageName: "hcm",
    path: "/job-position",
    element: <JobPositionList />,
  },
  {
    entityName: "HrSegment",
    packageName: "hcm",
    path: "/hr-segment",
    element: <HrSegmentList />,
  },
  {
    entityName: "InterviewSchedulingAndRescheduling",
    packageName: "hcm",
    path: "/interview-scheduling-and-rescheduling",
    element: <InterviewSchedulingAndReschedulingList />,
  },
  {
    entityName: "CandidateScreening",
    packageName: "hcm",
    path: "/candidate-screening",
    element: <CandidateScreeningList />,
  },
  {
    entityName: "CognitiveTestQuestion",
    packageName: "hcm",
    path: "/cognitive-test-question",
    element: <CognitiveTestQuestionList />,
  },
  {
    entityName: "CandidateAssessment",
    packageName: "hcm",
    path: "/candidate-assessment",
    element: <CandidateAssessmentList />,
  },
  {
    entityName: "CandidateSelection",
    packageName: "hcm",
    path: "/candidate-selection",
    element: <CandidateSelectionList />,
  },
  {
    entityName: "Hiring",
    packageName: "hcm",
    path: "/hiring",
    element: <HiringList />,
  },
  {
    entityName: "DocumentSubmissionScheduling",
    packageName: "hcm",
    path: "/document-submission-scheduling",
    element: <DocumentSubmissionSchedulingList />,
  },
  {
    entityName: "OrganizationalTitleSpecification",
    packageName: "hcm",
    path: "/organizational-title-specification",
    element: <OrganizationalTitleSpecificationList />,
  },
];
const gsmRoutes = [
  {
    entityName: "GsmRouting",
    packageName: "gsm",
    path: "/gsm-routing",
    element: <GsmRoutingList />,
  },
  {
    entityName: "GsmMessageLog",
    packageName: "gsm",
    path: "/gsm-message-log",
    element: <GsmMessageLogList />,
  },
];

const delegationRoutes = [
  {
    packageName: "delegation",
    entityName: "Delegation",
    path: "/define-delegation-to-me",
    element: <DelegatedToMe />,
  },
  {
    packageName: "delegation",
    entityName: "Delegation",
    path: "/define-delegation-by-me",
    element: <DelegationByMe />,
  },
];

const correspondenceRoutes = [
  {
    entityName: "CorrespondenceReceiverRouting",
    packageName: "correspondence",
    path: "/inbox",
    element: <CorrespondenceInboxList />,
  },
  // {
  //   entityName: "CorrespondenceReceiverRouting",
  //   packageName: "correspondence",
  //   path: "/sent",
  //   element: <CorrespondenceSentList />,
  // },
  //  {
  //   entityName: "Draft",
  //   packageName: "correspondence",
  //   path: "/draft",
  //   element: <CorrespondenceDraftList />,
  // },
];
const allListRoutes = [
  ...adminPanelListRoutes,
  ...ospChartsAndStaffsListRoutes,
  ...dbacDmacListRoutes,
  ...adminGeneralRoutes,
  ...adminPacRoutes,
  ...adminPavRoutes,
  ...binfRoutes,
  ...pacChartsAndStaffsListRoutes,
  ...generalChartsAndStaffsListRoutes,
  ...marketVisitRoutes,
  ...hrinfRoutes,
  ...marketPriceMonitorRoutes,
  ...financialRoutes,
  ...executiveRoutes,
  ...mlmRoutes,
  ...saleRepresentativesRoutes,
  ...hcmRoutes,
  ...correspondenceRoutes,
  ...gsmRoutes,
  ...delegationRoutes,
  ...medRepRoutes,
];
export default allListRoutes;
